import React from 'react';
import { Box, Text } from 'grommet';
import SHDImage from '@ui/Image/SHDImage';
import SHDGlow from '@ui/Glow/SHDGlow';
import SHDText from '@ui/Text/SHDText';
import SHDButton from '@ui/Button/SHDButton';
import parse from 'html-react-parser';
import * as ROUTES from '@constants/routes';

interface PaywallCtaInnerProps {
  headline: string;
  copy: string;
  onClick: () => void;
  customCopy?: { headline?: string; copy?: string };
  viewButton: boolean;
  signInUrl?: string;
  isLoggedIn: boolean;
  isTray?: boolean;
}

const PaywallCtaInner: React.FC<PaywallCtaInnerProps> = ({
  headline,
  copy,
  onClick,
  customCopy,
  isLoggedIn,
  isTray = false,
}) => {
  const defaultHeadline =
    'Unlock full access to all player highlights and play-by-play clips.';

  const resolvedHeadline = customCopy?.headline ?? headline;

  return (
    <Box
      gap="small"
      style={{
        position: 'relative',
        overflow: 'hidden',
        borderRadius: '16px',
        padding: '1.5rem 1rem',
        display: 'flex',
        border: isTray ? '' : '1px solid rgba(0, 0, 0, 0.10)',
        paddingBottom: isTray ? '3rem' : '1.5rem',
        paddingTop: isTray ? '3rem' : '1.5rem',
      }}
    >
      <SHDGlow
        color="#8BFF6D"
        top="0"
        left="0"
        size="80% 50%"
        blur="80px"
        style={{
          position: 'absolute',
          zIndex: 0,
          transform: 'translate(-30%, 0)',
        }}
      />
      <SHDGlow
        color="#D9FF7C"
        top="0"
        right="0"
        size="80% 50%"
        blur="80px"
        style={{
          position: 'absolute',
          zIndex: 0,
          transform: 'translate(30%, 0)',
        }}
      />

      <Box
        gap={!isLoggedIn ? 'large' : 'small'}
        style={{
          position: 'relative',
          zIndex: 1,
          alignItems: 'center',
          textAlign: 'center',
        }}
      >
        <SHDImage src="/paywall/pro.svg" alt="pro-logo" width={49.5} />

        <Text
          style={{
            color: '#000',
            textAlign: 'center',
            fontFamily: 'Messina Sans',
            fontSize: '24px',
            fontStyle: 'normal',
            fontWeight: 600,
            lineHeight: '28px',
          }}
        >
          {resolvedHeadline === defaultHeadline ? (
            <>
              Unlock full access to
              <br />
              all player highlights and
              <br />
              play-by-play clips.
            </>
          ) : (
            resolvedHeadline
          )}
        </Text>

        <SHDText style="body">
          {customCopy?.copy ? parse(customCopy.copy) : parse(copy)}
        </SHDText>

        <Box style={{ width: 176 }}>
          <SHDButton
            label="Unlock access"
            primary
            onClick={() => {
              !isLoggedIn
                ? window.location.replace(
                    `${ROUTES.SIGN_IN}?redirectUrl=${window.location.pathname.replace('/', '')}`
                  )
                : onClick();
            }}
          />
        </Box>

        {!isLoggedIn && (
          <SHDText style="body" textAlign="center">
            or{' '}
            <a
              href={`${ROUTES.SIGN_IN}?redirectUrl=${window.location.pathname.replace('/', '')}`}
              style={{
                fontWeight: '600',
                color: 'green',
                textDecorationLine: 'none',
              }}
            >
              Sign in
            </a>{' '}
            to view profile.
          </SHDText>
        )}
      </Box>
    </Box>
  );
};

export default PaywallCtaInner;
